import { memo } from 'react';
import { useTranslation } from '../../i18n/useTranslation';
import { Routes } from '../../../routes/routes';
import { setLocallyStoredUser } from '../../../utils/utils';
import BeamButton from './BeamButton';
import { ButtonSize, ButtonVariant, WorkbenchTheme } from '@workbench/core';
import { isDevOrLocalEnv } from '../../../configuration/confUtils';
import { useNavigation } from '../../../utils/customHooks';
import { useClientCompanyRegistrationContext } from '../../../components/client/companyRegistration/context/ClientCompanyRegistrationContext';
        
interface LogoutButtonProps {
    variant: ButtonVariant;
    size?: ButtonSize;
    theme?: WorkbenchTheme;
    className?: string;
}

const LogoutButton = (props: LogoutButtonProps) => {
    const translate = useTranslation();
    const navigate = useNavigation();
    const { setUserInfo } = useClientCompanyRegistrationContext();

    const handleLogoutUser = async () => {
        if (!isDevOrLocalEnv()) {
            window.location.href = `${window.location.origin}/${Routes.logout}`;
        } else {
            setUserInfo(undefined);
            setLocallyStoredUser(undefined);
            await navigate(Routes.home);
            window.location.reload();
        }
    };

    return (
        <BeamButton
            variant={props.variant}
            size={props.size}
            className={props.className}
            theme={props.theme}
            onClick={handleLogoutUser}
        >
            {translate('common_log_out')}
        </BeamButton>
    );
};

export default memo(LogoutButton);
